import React from "react";
import styled from "styled-components";
import TermsAndConditions from "../../Components/TermsAndConditions";

const PageContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 40px;
`;

const Logo = styled.img`
  height: 60px;
  margin-bottom: 20px;
`;

const PageTitle = styled.h1`
  color: #2c3e50;
  font-size: 32px;
  margin-bottom: 10px;
`;

const PageSubtitle = styled.p`
  color: #6c757d;
  font-size: 18px;
`;

const TermsPage = () => {
  return (
    <PageContainer>
      <PageHeader>
        <Logo src="/logo.png" alt="Isiqalo Guesthouse Logo" />
        <PageTitle>Terms and Conditions</PageTitle>
        <PageSubtitle>
          Please review our terms and conditions carefully before making a
          reservation
        </PageSubtitle>
      </PageHeader>

      <TermsAndConditions isLink={false} />
    </PageContainer>
  );
};

export default TermsPage;
